import { createSlice } from '@reduxjs/toolkit'

export const selectsSlice = createSlice({
  name: 'selects',
  initialState: {
    selects: [],
  },
  reducers: {
    setSelects: (state, action) => {
      state.selects = action.payload
      state.selects.sort((firstItem, secondItem) => {
        return firstItem.order > secondItem.order
      })
    },
    addSelects: (state, action) => {
      state.selects = [...state.selects, action.payload]
    },
    removeSelects: (state, action) => {
      state.selects = state.selects.filter((item) => item.id != action.payload)
    },
    changeSelectsPrice: (state, action) => {
      state.selects = state.selects.map((select) => {
        let price = select.id != action.payload.id ? select.price : action.payload.price
        let temp = select
        temp['price'] = price
        return temp
      })
    },
    editSelect: (state, action) => {
      state.selects = state.selects.map((select) => {
        if (select.id != action.payload.id) return select
        return {
          ...select,
          price: action.payload.price,
          label: action.payload.label,
          order: action.payload.order,
        }
      })

      console.log('end of edit')
    },
    changeSelectsOrder: (state, action) => {
      state.selects = state.selects.map((select) => {
        let order = select.id != action.payload.id ? select.order : action.payload.order
        let temp = select
        temp['order'] = order
        return temp
      })
    },
  },
})

// Action creators are generated for each case reducer function
export const {
  setSelects,
  addSelects,
  removeSelects,
  changeSelectsPrice,
  changeSelectsOrder,
  editSelect,
} = selectsSlice.actions

export default selectsSlice.reducer
